// The top bar's loading sign: the logo spinning while the app fetches or saves data anywhere (a page loading,
// a Sync, a background refresh, a change being written). The chat, presence, notification and session polls
// run every few seconds on their own and don't count. It shows once a fetch has taken a moment (a quick one
// doesn't flash it) and stays briefly after, so back-to-back fetches don't make it blink.
import { useEffect, useState } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { LogoSpin } from './ui.js';

const QUIET = new Set(['collab', 'presence', 'notifications', 'me']);

export function FetchingLogo() {
  const fetching = useIsFetching({ predicate: (q) => !QUIET.has(String(q.queryKey[0])) });
  const saving = useIsMutating();
  const busy = fetching + saving > 0;
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShown(busy), busy ? 250 : 400);
    return () => clearTimeout(t);
  }, [busy]);
  // (silent for screen readers: a background refresh every half minute isn't news; the page says what it loads)
  return (
    <span className="topbar-fetch" aria-hidden="true" title={shown ? 'Loading data…' : undefined} data-busy={shown || undefined}>
      {shown && <LogoSpin size={22} decorative />}
    </span>
  );
}
